var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.hasCatalogList)?_c(_setup.CatalogList,{key:_setup.id,attrs:{"id":_setup.id,"catalog-list":_setup.catalogList}}):_vm._e(),_c('div',{staticClass:"empty-container"},[(!_setup.hasCatalogList && !_setup.isLoading)?_c(_setup.EmptyList,{attrs:{"text":"추천 콘텐츠가 없어요."}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }